import * as types from "~/store/followUpExam/types";

const initialState = {
  patientExam: null,
  idReExam: "",
  listReExam: [],
  isCheck: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_FOLLOW_UP_EXAM: {
      return { ...state };
    }
    case types.GET_FOLLOW_UP_EXAM_SUCCESS: {
      return { ...state, patientExam: { ...action.payload } };
    }
    case types.RESET_FOLLOW_UP_EXAM: {
      return initialState;
    }
    case types.SAVE_REEXAM_ID: {
      return {
        ...state,
        idReExam: action.id
      };
    }
    case types.CHECK_FOLLOW_UP_EXAM: {
      return {
        ...state,
        isCheck: true
      };
    }
    case types.CHECK_FOLLOW_UP_EXAM_SUCCESS: {
      return {
        ...state,
        listReExam: action.payload
      };
    }
    case types.RESET_STATUS_CHECKING: {
      return {
        ...state,
        isCheck: false
      };
    }
    case types.CLEAR_LIST_FOLLOW_UP_EXAM: {
      return {
        ...state,
        listReExam: [...initialState.listReExam]
      };
    }
    default:
      return state;
  }
};
